//
//
//
//
//
//
//
//

export default {
  name: 'leon-message',
  props: {
    time: {
      type: Number,
      default: 2000
    }
  },
  data () {
    return {
      message: '',
      isShow: true
    }
  },
  mounted () {
    this.close()
  },
  methods: {
    close () {
      window.setTimeout(() => {
        this.isShow = false
      }, this.time)
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugin/LeonMessage/src/main.vue